import EmojiBest from "Assets/images/emoji/emoji-best.svg";
import EmojiBestest from "Assets/images/emoji/emoji-bestest.svg";
import EmojiBetter from "Assets/images/emoji/emoji-better.svg";
import EmojiGood from "Assets/images/emoji/emoji-good.svg";
import EmojiOk from "Assets/images/emoji/emoji-ok.svg";

export const imageGeneration = text => {
  switch (text) {
    case "EmojiBestest":
      return EmojiBestest;
    case "EmojiBest":
      return EmojiBest;
    case "EmojiBetter":
      return EmojiBetter;
    case "EmojiGood":
      return EmojiGood;
    case "EmojiOk":
      return EmojiOk;
    default:
      break;
  }
};
